export const UPDATE_PERMISSIONS='Update permissions'
